module.exports = __webpack_public_path__ + "static/media/logo.83ce8f89.svg";